import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { StarIcon } from 'lucide-react';
import { trackAddToCart } from '../lib/meta-pixel';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-white" data-id="element-157">
      <div className="max-w-lg mx-auto" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-cream-50 border-2 border-terracotta-100 rounded-3xl p-8 md:p-12 text-center shadow-xl" data-id="element-159">
          {/* Decorative star */}
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-gold-500 text-white p-3 rounded-full shadow-lg" data-id="element-160">
            <StarIcon className="w-6 h-6 fill-current" data-id="element-161" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-brown-800 mb-4 mt-4" data-id="element-162">
            Edición lanzamiento: <br data-id="element-163" />
            <span className="text-terracotta-500" data-id="element-164">$6.36 USD</span>
          </h2>

          <p className="text-stone-600 mb-10 text-lg" data-id="element-165">
            Lo dejo ultra accesible para que empieces sin presión y sin
            sobrepensar.
          </p>

          <Button size="lg" fullWidth className="text-xl py-8 mb-6 shadow-terracotta-500/20" onClick={() => {
          trackAddToCart();
          window.open('https://recursosclaros.com/cart/43661477871713:1', '_blank');
        }} data-id="element-166">
            <span className="line-through opacity-60 text-base mr-2" data-id="element-167">$27</span>{' '}
            Comprar ahora — $6.36
          </Button>

          <p className="text-sm text-stone-500 font-medium flex flex-wrap justify-center gap-3" data-id="element-168">
            <span data-id="element-169">Acceso inmediato</span>
            <span className="hidden sm:inline" data-id="element-170">•</span>
            <span data-id="element-171">PDF descargable</span>
            <span className="hidden sm:inline" data-id="element-172">•</span>
            <span data-id="element-173">En español</span>
          </p>
        </motion.div>
      </div>
    </section>;
}